// 0女，1男，2未知
export const patientGenderMap = [
  { label: '女', value: 0 },
  { label: '男', value: 1 },
  { label: '未知', value: 2 }
]
// "用药状态，0：未服用 1：服用中 2:疗程即将结束 3:疗程已结束")
export const medicationStatusMap = [
  { label: '未服用', value: 0 },
  { label: '服用中', value: 1 },
  { label: '疗程即将结束', value: 2 },
  { label: '疗程已结束', value: 3 }
]
// 就诊人关系
export const patientRelationMap = ['本人', '父母', '', '爱人', '子女', '亲戚朋友', '其他']
// 诊断类型 诊断1，证型2
export const diagnosisTypeMap = ['--', '诊断', '证型']
